//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    /**
     * Steps: list of elements that will be show when the step is on the viewport
     * Every step is an object with this structure:
     * {
     *  title: String
     *  description: String
     *  image: String (image url)
     * }
     */
    steps: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      imageSrc: ''
    }
  },
  computed: { },
  mounted () {
    if (this.isDesktop()) {
      window.addEventListener('scroll', this.highlightStepOnViewport)
    }
  },
  methods: {
    slideChanged (slide) {
      this.currentSlide = slide
    },
    highlightStepOnViewport () {
      const steps = document.getElementById('timeline') ? document.getElementById('timeline').childNodes : []
      steps.forEach((step, i) => {
        const documentScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
        const elTop = step.offsetTop - documentScrollTop
        const windowHeight = window.innerHeight
        const gridTop = windowHeight * 0.4
        const gridBottom = windowHeight * 0.6
        if (elTop >= gridTop && elTop <= gridBottom) {
          this.showImage = true
          step.classList.add('active')
          step.classList.add('completed')
          step.children[0].classList.add('base-scroll-carousel__step-counter-active')
          this.imageSrc = this.steps[i].image
        } else {
          step.classList.remove('completed')
          step.classList.remove('active')
          step.children[0].classList.remove('base-scroll-carousel__step-counter-active')
        }
      })
    }
  }
}
